import React, { useState } from 'react';
import { Stack, Typography, Icon, Space, Button } from 'witmeg-ui-system';
import "../styles/defaultStyles.scss"
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import "@fontsource/inter";
import "@fontsource/plus-jakarta-sans";
import RetailCartSummary from '../../../../common/RetailCartSummary';
import { getCurrencyFormat, isECommerceProcessPath, LOCAL_STORAGE_ITEMS_NAMES } from '../../../RestaurantWidget/utilities/helper/helper';
import { deleteCart, deleteCartItem, getCartItemsToCart, predictPrice, updateCartItemQuantity } from '../../../RestaurantWidget/utilities/api/restaurantsService';
import DeletePopup from './DeletePopup';
import { setOrderCartItems, setOrderData, setOrderDataPayment, setOrderEmpty, setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import editIc from "../../assets/edit.svg"
import deleteIc from "../../assets/trash.svg"
import closeIc from "../../assets/close.svg"
import { v4 as uuidv4 } from 'uuid';
import { circularProgressClasses } from '@material-ui/core';
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"
import VOUCHER_PLACEHOLDER from "../../assets/images/Images/vouchers-placeholder.jpg"

const CartPopup = ({ toggleVisibility, updateCartItemCallback, websiteType, setCheckoutFailed, isStoreOpen, setIsStoreClosed }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isCheckLoading, setIsCheckLoading] = useState("")
    const [isDeleteLoading, setIsDeleteLoading] = useState(false)



    const history = useHistory();
    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const retailDataState = useSelector((state) => state.retailData);

    const selectedOrderTypeOriginal = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const selectedOrderType = websiteType === "Restaurant" ? selectedOrderTypeOriginal : "retail"
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    const isRetailCartAvailable = retailDataState.cart && retailDataState.cart.length > 0 ? true : false

    const isButtonsDisabled = !isCartDataAvailable || isECommerceProcessPath();
    const companyDetails = useSelector((state) => state.companyData.companyDetails);


    const isOrderSuccessPage = window.location.pathname.split('/')[1] === 'order-success' ? true : false;
    const currencyFormat = getCurrencyFormat(restaurantDataState.currency);
    const acceptOrders = companyDetails?.settings?.OnlineOrder?.AcceptOrders || true
    const onCheckoutClick = () => {
        history.push('/checkout');
        toggleVisibility();
    };
    const isBlockedHour = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.settings?.OnlineOrder?.BlockedHours.find(day => day.Day === currentDay);
        if (!today) return false;

        for (let hours of today.Time) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    const handleOrdertype = () => {
        let type = "delivery"
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                type = "delivery";
                break;
            case "DINE_IN":
                type = "table";
                break;
            case "TAKE_AWAY":
                type = "collection";
                break;
            default:
                type = "delivery";
                break;
        }
        dispatch(setSelectedOrderType(type))
    }
    const getTotal = (data) => {
        let responsePrice = data?.Gross?.AmountE5
        let totalPrice = restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.AmountE5 + responsePrice
        return {
            AmountE5: totalPrice,
            Formatted: `£${(totalPrice / 100).toFixed(2)}`,
            CurrencyCode: "GBP"
        }
    }
    const onCheckoutClickRestaurant = () => {
        if (restaurantDataState.orderDetails.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER") {
            setIsCheckLoading(true)
            let data = {
                "CloudLocationID": JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID,
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
                "ReferenceNo": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_LOC_ID)
            }
            predictPrice(data).then((response) => {
                if (response) {
                    let dataRes =
                    {
                        Details: response.Details,
                        Total: getTotal(response.Total)
                    }
                    setIsCheckLoading(false)

                    dispatch(setOrderDataPayment(dataRes))
                    handleOrdertype()
                    history.push('/order/checkout');
                    toggleVisibility();
                } else {
                    setIsCheckLoading(false)

                    handleOrdertype()
                    history.push('/order/checkout');
                    toggleVisibility();
                }
            }).catch((error) => {
                if (error.response.status === 404) {
                    setIsCheckLoading(false)

                    setCheckoutFailed(error.response.data.Result)
                }
            })
        } else {
            handleOrdertype()
            history.push('/order/checkout');
            toggleVisibility();
        }

    };
    const onContinueShoppingClick = () => toggleVisibility();
    const showCartDetails = () => {
        toggleVisibility();
        history.push('/cart')
    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsLoading(item.ID)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            if (window.location.pathname.includes(item.ID)) {
                let found = response.Carts.Items.find((val) => val.ID === item.ID)
                const cartItem = found ? found : response.Carts.Items[response.Carts.Items.length - 1]
                const quantities = reduceQuantity([cartItem])
                const updatQty = assignIdsAndParentIds(quantities)
                localStorage.setItem("QUANTITY", JSON.stringify([updatQty]))
                toggleVisibility();
                history.push('/item/' + cartItem.CartItemID + "/" + item.ID)

            }
            dispatch(setOrderData(response))
            setIsLoading("")
        })
    }
    const decreaseQty = (item) => {
        setIsLoading(item.ID)

        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                if (window.location.pathname.includes(item.ID)) {
                    let found = response.Carts.Items.find((val) => val.ID === item.ID)
                    const cartItem = found ? found : response.Carts.Items[response.Carts.Items.length - 1]
                    const quantities = reduceQuantity([cartItem])
                    const updatQty = assignIdsAndParentIds(quantities)
                    localStorage.setItem("QUANTITY", JSON.stringify([updatQty]))
                    toggleVisibility();
                    history.push('/item/' + cartItem.CartItemID + "/" + item.ID)
                }
                dispatch(setOrderData(response))

                setIsLoading("")

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                dispatch(setOrderData(response))

                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    if (window.location.pathname.includes(item.ID)) {
                        toggleVisibility();
                        history.push("/")
                    }
                    setIsLoading("")
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "" && !isDeleteLoading) {
            setIsDeleteLoading(true)
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCart(customerID, cloud).then((response) => {
                            if (response) {
                                dispatch(setOrderData(response))

                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    if (window.location.pathname.includes(isDeleteItem)) {
                        toggleVisibility();
                        history.push("/")

                    }
                    setIsDeleteLoading(false)
                }
            })
        }
    }


    const getPrice = (
        baseTotalPrice
    ) => {
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
            case "table":
                priceValue = baseTotalPrice.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = baseTotalPrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = baseTotalPrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }

    const getCartTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Net?.Formatted ?? "£ 0.00"

    }
    let itemsAvailable = restaurantDataState.orderCartData?.Items?.some(itemVal => itemVal.MetaData === null) ?? false;
    const getRestaurantComponent = () => {
        return (
            <>
                <div className="eco-mt-36">
                    <Stack horizontalAlign="space_between" className="sub-total-contianer">
                        <div type="text" pattern="bold" className="sub-total-label">Sub Total</div>
                        <div type="text" pattern="bold" className="sub-total">
                            {isLoading !== "" ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "35px" }}>XXXXXXXXXX</div> : getCartTotal()}
                        </div>
                    </Stack>
                    <div className={isCartDataAvailable ? !itemsAvailable ? 'rest-btn-conatiner' : acceptOrders ? !isBlockedHour() ? 'rest-btn-conatiner' : 'rest-btn-conatiner-disable ' : 'rest-btn-conatiner-disable ' : 'rest-btn-conatiner-disable '}>
                        <div className="checkout-button" onClick={() => {
                            if (!itemsAvailable) {
                                if (isCartDataAvailable) {
                                    if (isLoading === "" && !isCheckLoading) {
                                        onCheckoutClickRestaurant()
                                    }
                                }
                            } else {
                                if ((!isBlockedHour() && acceptOrders)) {
                                    if (isStoreOpen()) {
                                        if (isCartDataAvailable) {
                                            if (isLoading === "" && !isCheckLoading) {
                                                onCheckoutClickRestaurant()
                                            }
                                        }
                                    } else {
                                        setIsStoreClosed(true)
                                    }
                                }
                            }

                        }} >{isCheckLoading &&
                            <div className='loader-btn' />}
                            Check Out
                        </div>
                        <div className="continue-shopping-button" onClick={onContinueShoppingClick}>
                            Continue Shopping
                        </div>
                    </div>
                </div>

            </>
        )
    }
    const getOtherComponent = () => {
        return (
            <div className="eco-mt-24">
                <Stack
                    horizontalAlign="space_between" className="eco-order-summary-row">
                    <Typography type="text" className="eco-order-summary-label">VAT</Typography>
                    <Typography type="text" pattern="bold" className="eco-order-summary-total">
                        {/* {currencyFormat(isCartDataAvailable ? restaurantDataState.cartDetails.total[selectedOrderType]?.vatAmount : 0)} */}
                    </Typography>
                </Stack>
                <Stack horizontalAlign="space_between" className="eco-order-summary-total-row">
                    <Typography type="text" pattern="bold" className="eco-order-summary-total-label">Total:</Typography>
                    <Typography type="text" pattern="bold" className="eco-order-summary-total-bg">
                        {retailDataState.cart.reduce((accumulator, currentItem) => {
                            return accumulator + currentItem.productDetails.SellingPricesArray.SellingPrice * currentItem.quantity;
                        }, 0)}
                    </Typography>
                </Stack>
                <>
                    <Button fullWidth variant="primary" className="eco-mb-12 eco-checkout-button" onClick={onCheckoutClick} disabled={!isRetailCartAvailable}>
                        Check Out
                    </Button>
                    <Button fullWidth variant="outline" className="eco-mb-12 eco-continue-shopping-button" onClick={showCartDetails} disabled={isOrderSuccessPage}>
                        View Cart
                    </Button>
                </>

            </div>)
    }

    const renderModifierGroups = (selectedGroup, item) => {
        return (
            <div>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title}  <span className="qty-box">{Math.floor(selectedItem.Quantity.Amount / item.Quantity.Amount)}</span>
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex} > {renderModifierGroups(nestedGroup, item)}</span>
                                ))}
                            </span>
                        )}
                        <br />
                    </span>
                ))}
            </div>
        );
    };
    const getItemPrice = (baseUnit, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery?.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway?.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn?.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });

        return getPriceData(baseUnit || {}, quantity);
    };
    const assignIdsAndParentIds = (cartItem) => {
        const recursiveAssign = (item, parentId = null) => {
            item.ValueID = item.ValueID || uuidv4();

            if (parentId) {
                item.ParentID = parentId;
            }

            if (Array.isArray(item.SelectedModifierGroups)) {
                item.SelectedModifierGroups.forEach(group => {
                    group.ParentID = item.ValueID;

                    if (Array.isArray(group.SelectedItems)) {
                        group.SelectedItems.forEach(subItem => {
                            recursiveAssign(subItem, group.ParentID);
                        });
                    }
                });
            }
        };

        recursiveAssign(cartItem);
        return cartItem;
    };
    const reduceQuantity = (quantities) => {
        if (!quantities.length) return;

        const updateSelectedItems = (selectedItems, multiplier) => {
            return selectedItems.map(itemVal => {
                let updatedAmount = itemVal.Quantity.Amount / multiplier;
                let newAmount = Number.isInteger(updatedAmount) ? updatedAmount : Math.round(updatedAmount);

                return {
                    ...itemVal,
                    Quantity: {
                        ...itemVal.Quantity,
                        Amount: newAmount
                    },
                    PriceInfo: {
                        ...itemVal.PriceInfo,
                        BaseTotalPrice: getItemPrice(itemVal.PriceInfo.BaseUnitPrice, newAmount)
                    },
                    SelectedModifierGroups: itemVal.SelectedModifierGroups.map(group => ({
                        ...group,
                        SelectedItems: updateSelectedItems(group.SelectedItems, multiplier)
                    }))
                };
            });
        };

        const parentItem = { ...quantities[0] };

        return {
            ...parentItem,
            SelectedModifierGroups: parentItem.SelectedModifierGroups.map(group => ({
                ...group,
                SelectedItems: updateSelectedItems(group.SelectedItems, parentItem.Quantity.Amount)
            }))
        };
    };
    const deleteCartAll = () => {
        setIsLoading("00000")
        dispatch(setOrderCartItems([]))
        deleteCart().then((response) => {
            if (response) {
                dispatch(setOrderEmpty())
                onContinueShoppingClick()
                setIsLoading("")


            } else {
                setIsLoading("")
            }
        })
    }

    return (
        <div className='cart-popup'>

            <>
                <div className="eco-product-list">

                    <div className='cart-header'>
                        <div className='cart-header-conat'>
                            <div className='cart-title'>Cart</div>
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 && <div className='cart-items-count'>{restaurantDataState.orderCartData.Items.length} item{restaurantDataState.orderCartData.Items.length === 1 ? "" : "s"}</div>
                            }
                        </div>
                        <div>
                            <img alt='' src={closeIc} className='close-icon ' onClick={() => { toggleVisibility() }} />
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 1 && <div className="clear-button" onClick={() => {

                                deleteCartAll()



                            }} >
                                Clear All
                            </div>}
                        </div>


                    </div>
                    {websiteType === "Restaurant" ?
                        <>
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 ? restaurantDataState.orderCartData.Items.map((item, index) => {
                                const _hasAddons = item.SelectedModifierGroups.length > 0;
                                return (
                                    <Stack className="eco-mb-20 " verticalAlign="v_start">
                                        <Typography
                                            style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : item.MetaData === null ? IMAGE_PLACEHOLDER : VOUCHER_PLACEHOLDER})`, objectFit: !item.PictureURL === "" ? "fill" : "" }}
                                            className="cart-item-image">
                                        </Typography>
                                        <div className='item-details-container'>
                                            <div className='item-details-container-left'>
                                                <div>
                                                    <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                    <div className="modifiers-text-sum">
                                                        {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                            <span key={index}> {renderModifierGroups(selectedGroup, item)} </span>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className='item-cart-price'>        {isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>{getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                                    : getPrice(item.PriceInfo.TotalPrice)}</div>
                                            </div>

                                            <div className='item-details-container-right'>
                                                {isLoading === item.ID ? <div style={{ marginTop: "-8px" }}><Space > <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "35px" }}>XXXXXXXXXXXXXXXXXXX</div></Space></div> : <>
                                                    <div className='item-cart-qty-container'>
                                                        <div className='quantity-ic-cont' onClick={() => {
                                                            decreaseQty(item)
                                                        }}> <Icon name="minus" className="quantity-ic" size={16} /></div>
                                                        <div className='qty-cont'> {item.Quantity.Amount}</div>
                                                        <div className='quantity-ic-cont' onClick={() => {
                                                            increaseQty(item)
                                                        }}> <Icon name="plus" className="quantity-ic" size={16} /></div>
                                                    </div>
                                                    <div className='cart-action' onClick={() => {
                                                        setIsDeleteItem(item.ID)
                                                    }}> <img alt='' src={deleteIc} /></div>
                                                    <div className='cart-action' onClick={() => {
                                                        const quantities = reduceQuantity([item])
                                                        const updatQty = assignIdsAndParentIds(quantities)
                                                        localStorage.setItem("QUANTITY", JSON.stringify([updatQty]))
                                                        toggleVisibility();
                                                        history.push('/item/' + item.CartItemID + "/" + item.ID)
                                                    }}>
                                                        <img alt='' src={editIc} />
                                                    </div>
                                                </>}
                                            </div>
                                        </div>
                                    </Stack>
                                )
                            }) :
                                <Stack className="item eco-mb-16 eco-mt-16" style={{ display: "flex", justifyContent: "center" }}>
                                    <div>No cart items</div>
                                </Stack>

                            }
                        </>
                        : <div>
                            <RetailCartSummary />
                        </div>
                    }
                </div>
                {websiteType === "Restaurant" ? getRestaurantComponent() : getOtherComponent()}
            </>
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem}
                isLoading={isDeleteLoading} />
        </div>
    );

}
export default CartPopup